// extracted by mini-css-extract-plugin
export default {"card":"leoni-module__card--_bp2D","imgContainer":"leoni-module__imgContainer--_9101","bubble":"leoni-module__bubble--_3WW0","textWrap":"leoni-module__textWrap--ARLan"};